// pages/SupportCenter.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_CONFIG } from "../app-config";
import BannerCarousel from "../components/banner-carousel";
import SidebarHeader from "../components/SidebarHeader";
import BottomNav from "../components/bottom-menu";
import toast, { Toaster } from 'react-hot-toast';
import { apiCall } from "../utils/api";
import Bmnemonic_PNG from "../assets/image/Bmnemonic_PNG.png"
import { FiArrowLeft } from "react-icons/fi";

const COLORS = APP_CONFIG.colors;

const faqs = [
    {
        q: "How do I recharge my mobile?",
        a: "Go to Home, select 'Mobile Recharge', enter your 10-digit number, select your operator and circle, pick a plan or enter an amount, and click 'Recharge Now'. The amount will be deducted from your wallet.",
    },
    {
        q: "How long does recharge take?",
        a: "Most recharges are instant. However, sometimes operator delays can occur. If your recharge is pending, please wait for up to 30 minutes before raising a ticket.",
    },
    {
        q: "What if my recharge fails?",
        a: "If a recharge fails, any deducted amount is usually refunded to your wallet instantly. In case it's not refunded within 2 hours, please contact our support team with the transaction ID.",
    },
    {
        q: "How do I add money to wallet?",
        a: "Go to 'Add Money' from the Home screen or Profile. Enter the amount, select your preferred payment method (UPI, Debit Card, etc.), and complete the transaction. Your balance will update instantly.",
    },
    {
        q: "How does referral work?",
        a: "Share your unique referral code found in 'Refer & Earn' with friends. When they sign up using your code, you earn ₹50 and they get ₹25 as a welcome bonus once they complete their first transaction.",
    },
    {
        q: "How do I delete my account?",
        a: "You can delete your account by going to Profile > Account Deletion. Please note that this action is permanent and you will lose your wallet balance and transaction history.",
    },
];

function SupportCenter() {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const handleEmailSupport = () => {
        const email = APP_CONFIG.contacts.email;
        window.location.href = `mailto:${email}?subject=Support Request - ${APP_CONFIG.app.name}`;
    };

    const handleCallSupport = () => {
        const phone = APP_CONFIG.contacts.call;
        window.location.href = `tel:${phone}`;
    };

    const handleWhatsAppSupport = () => {
        const whatsapp = APP_CONFIG.contacts.whatsapp;
        window.open(whatsapp, '_blank');
    };

    const handleChatSupport = () => {
        toast.success("Chat support coming soon!", {
            duration: 2000,
            position: "bottom-center",
            style: {
                background: COLORS.surfaceColor,
                color: COLORS.textPrimary,
                border: `1px solid ${COLORS.borderColor}`,
            },
        });
    };

    const ContactCard = ({ icon, label, sub, onClick }) => (
        <div
            onClick={onClick}
            className="rounded-2xl p-4 py-3 flex flex-col items-center cursor-pointer text-center transition-all duration-200 active:scale-98 hover:shadow-lg"
            style={{
                background: COLORS.bgColor,
                border: `1px solid ${COLORS.borderColor}`,
                borderRadius: COLORS.borderRadius,
                transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = COLORS.primaryColor;
                e.currentTarget.style.boxShadow = `0 4px 16px ${COLORS.primaryColor}20`;
                e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = COLORS.borderColor;
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.transform = "translateY(0)";
            }}
        >
            <div
                className="w-10 h-10 rounded-full flex items-center justify-center mb-2 transition-all duration-300"
                style={{
                    background: `${COLORS.primaryColor}15`,
                }}
            >
                {icon}
            </div>
            <span
                className="text-xs font-semibold"
                style={{ color: COLORS.textPrimary }}
            >
                {label}
            </span>
            <span
                className="text-[10px]"
                style={{ color: COLORS.textSecondary }}
            >
                {sub}
            </span>
        </div>
    );

    return (
        <SidebarHeader>
            <div className="flex items-center gap-3 pb-4">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-200 hover:bg-gray-300 transition"
                >
                    <FiArrowLeft className="text-xl" />
                </button>
                <h1 className="text-lg font-semibold text-gray-800">
                    Support Team
                </h1>
            </div>
            <div className="max-w-7xl mx-auto mb-16">
                {/* Contact Cards - Grid with 4 columns on desktop, 2 on tablet, 2 on mobile */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8">
                    <ContactCard
                        label="WhatsApp"
                        sub="Auto Support"
                        onClick={handleWhatsAppSupport}
                        icon={
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={COLORS.primaryColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                            </svg>
                        }
                    />
                    <ContactCard
                        label="Chat"
                        sub="Live Support"
                        onClick={handleChatSupport}
                        icon={
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={COLORS.primaryColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                            </svg>
                        }
                    />
                    <ContactCard
                        label="Email"
                        sub="24h response"
                        onClick={handleEmailSupport}
                        icon={
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={COLORS.primaryColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                <polyline points="22,6 12,13 2,6" />
                            </svg>
                        }
                    />
                    <ContactCard
                        label="Call"
                        sub="9am - 9pm"
                        onClick={handleCallSupport}
                        icon={
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={COLORS.primaryColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                            </svg>
                        }
                    />
                </div>

                {/* FAQ Section */}
                <div className="flex items-center justify-between mb-4">
                    <h3
                        className="text-sm font-bold"
                        style={{ color: COLORS.textPrimary }}
                    >
                        Frequently Asked Questions
                    </h3>
                </div>

                <div className="mb-8">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="overflow-hidden rounded-lg mb-2"
                            style={{
                                border: `1px solid ${COLORS.borderColor}`,
                            }}
                        >
                            <div
                                onClick={() => toggleAccordion(index)}
                                className="flex items-center justify-between py-4 cursor-pointer hover:bg-opacity-5 px-2 rounded-lg transition-all duration-200"
                                style={{
                                    background:
                                        openIndex === index
                                            ? `${COLORS.primaryColor}08`
                                            : "transparent",
                                }}
                                onMouseEnter={(e) => {
                                    if (openIndex !== index) {
                                        e.currentTarget.style.background =
                                            `${COLORS.primaryColor}05`;
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (openIndex !== index) {
                                        e.currentTarget.style.background = "transparent";
                                    }
                                }}
                            >
                                <span
                                    className="text-sm font-medium flex-1 pr-4"
                                    style={{ color: COLORS.textPrimary }}
                                >
                                    {faq.q}
                                </span>

                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke={COLORS.textSecondary}
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="transition-transform duration-300 flex-shrink-0"
                                    style={{
                                        transform:
                                            openIndex === index
                                                ? "rotate(180deg)"
                                                : "rotate(0deg)",
                                    }}
                                >
                                    <polyline points="6 9 12 15 18 9" />
                                </svg>
                            </div>

                            <div
                                className="transition-all duration-300 ease-in-out overflow-hidden"
                                style={{
                                    maxHeight: openIndex === index ? "300px" : "0",
                                    opacity: openIndex === index ? 1 : 0,
                                    paddingLeft: openIndex === index ? "12px" : "0",
                                    paddingRight: openIndex === index ? "12px" : "0",
                                    paddingBottom: openIndex === index ? "16px" : "0",
                                }}
                            >
                                <p
                                    className="text-xs leading-relaxed"
                                    style={{ color: COLORS.textSecondary }}
                                >
                                    {faq.a}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Toaster />

            <style>
                {`
                    .active\\:scale-98:active {
                        transform: scale(0.98);
                    }
                    .active\\:scale-95:active {
                        transform: scale(0.95);
                    }
                `}
            </style>
        </SidebarHeader>
    );
}

export default SupportCenter;